module.exports = __webpack_public_path__ + "img/4_de.08fd0b24.jpg";